import { SummaryType } from './types';

export const TIPS_SUBHEADING =
  'Efficiently track and distribute employee tips, view breakdowns by payment methods and access tip details by Ticket ID.';

export const INACCURATE_TIPS_DATE_LABEL = 'June 7, 2024';

export const SUMMARY_TYPE_OPTIONS: Array<{
  value: SummaryType;
  label: string;
}> = [
  { value: SummaryType.EMPLOYEE, label: 'By Employee details' },
  { value: SummaryType.PAYMENT_TYPE, label: 'By Payment type' },
];

export const NA_EMPLOYEE_TOOLTIP =
  'No mapping of tips on ACH transactions with employees at the moment. Please contact support if there are any tips issues.';

export const NA_EMPLOYEE_ID_TOOLTIP =
  'Unable to get the Employee ID. Please check if it’s added as user info under User Management section in your Treez Dashboard.';
